module.exports = __webpack_public_path__ + "static/media/mwb.04414573.jpg";